import styled, { css } from 'styled-components';
import { TextStyle } from 'components/text';
import { FontSize, device } from 'commons';

export const Wrapper = styled.div<{ $columnsCount: number }>`
  width: 80%;
  max-width: 600px;
  display: grid;
  grid-template-columns: repeat(${({ $columnsCount }) => $columnsCount}, 1fr);
  justify-content: center;
  padding: 0 0 20px;
  margin: 40px auto 35px;
  position: relative;
  left: 19px;

  @media (max-width: ${device.mobile}px) {
    left: 0;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 32px;
    height: 32px;
    color: ${({ theme }) => theme.neutral_300};

    @media (max-width: ${device.mobile}px) {
      width: 24px;
      height: 24px;
    }
  }
`;

const Item_filled = css`
  ${Icon} {
    svg {
      color: ${({ theme }) => theme.success_300};
    }
  }

  ${TextStyle} {
    color: ${({ theme }) => theme.neutral_500};
  }
`;

export const Item = styled.div<{ $filled: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;

  ${TextStyle} {
    width: max-content;
    max-width: 110px;
    margin-top: 5px;
    text-align: center;
    color: ${({ theme }) => theme.neutral_300};

    @media (max-width: ${device.mobile}px) {
      width: auto;
      font-size: ${FontSize.font10};
    }
  }

  &:after {
    content: '';
    position: absolute;
    min-width: 40px;
    border-top: 2px dotted ${({ theme }) => theme.neutral_300};
    height: 2px;
    top: 24%;
    right: -24%;
    width: 50%;
  }

  &:last-child {
    &:after {
      content: none;
    }
  }

  ${({ $filled }) => $filled && Item_filled}
`;
